/*
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2023-03-07 14:46:43
 */
import { defineStore } from 'pinia';
import { MenuApi } from '@/api/MenuApi.js';
import { message, Modal } from 'ant-design-vue';
import Mock from '@/layouts/mock.json';



const useStore = defineStore('store',{
    state:()=>{
        return {
            lang:'',
            userInfo:null,
            menuList:[],
            funList:[],
            routerList:[],
        }
    },
    actions:{
        changeLang(val){
            this.lang = val
        },

        changeUserInfo(val){
            this.userInfo = val
            console.log(this.userInfo,'this.userInfo')  
        },

        // 权限菜单、功能点
        async getMenuList(){
            let userInfo = !!this.userInfo? this.userInfo : JSON.parse(sessionStorage.getItem('userInfo'))
            let param = {
                role_ids: userInfo.role.split(','),
                menu_types: [0,2],
                permission_flag: true,
            }
            let res = await MenuApi.getInstance().getMenuTree(param, userInfo.id)
            if(res.code === 0){
                function getFunData(data) {
                    let result = [];
                    data.filter(item => item.bind_flag).forEach(item => {
                        if (item.menu_type === 2) {
                            result.push(item);
                        }
                        if (item.children && item.children.length > 0) {
                            result = result.concat(getFunData(item.children));
                        }
                    });
                    return result;
                }

                function getBindFlagTrueTree(data) {
                    return data.filter(item => item.bind_flag && item.menu_type === 0).map(item => {
                            let newItem = { ...item };
                            if (item.children && item.children.length > 0) {
                                const filteredChildren = getBindFlagTrueTree(item.children);
                                if (filteredChildren.length > 0) {
                                    newItem.children = filteredChildren;
                                } else {
                                    delete newItem.children;
                                }
                            } else {
                                delete newItem.children;
                            }
                            return newItem;
                        });
                }
    
                function filterMockByBindFlagTrueTree(mockList, bindTree) {
                    return mockList.map(mockItem => {
                            const match = bindTree.find(bindItem => bindItem.menu_path === mockItem.path);
                            if (match) {
                                let newItem = { ...mockItem };
                                if (mockItem.children && match.children) {
                                    // 递归对子节点进行匹配
                                    const filteredChildren = filterMockByBindFlagTrueTree(mockItem.children, match.children);
                                    if (filteredChildren.length > 0) {
                                        newItem.children = filteredChildren;
                                    } else {
                                        delete newItem.children;
                                    }
                                } else {
                                    delete newItem.children;
                                }
                                return newItem;
                            }
                            return null;
                        }).filter(Boolean);
                }

                function getRouterData(data){
                    let result = [];
                    data.forEach(item => {
                        if (item.children && item.children.length > 0) {
                            result = result.concat(getRouterData(item.children));
                        }else{
                            result.push(item.path)
                        }
                    });
                    return result;
                }
    
                this.menuList = filterMockByBindFlagTrueTree(Mock.data, getBindFlagTrueTree(res.data))
                console.log(this.menuList,'菜单数据')
    
                this.funList = getFunData(res.data)
                console.log(this.funList,'功能点数据')

                this.routerList = getRouterData(this.menuList)
                console.log(this.routerList,'路由数据')
                
            }else{
                message.error(res.msg || res.message)
            }
        }
    }  
})

export {
    useStore
}